import React, { useEffect, useRef } from 'react'
import animationSvg from '!!raw-loader!../../../images/renshin-animation.svg'

// The source clip runs 1.03s. A light speed-up trims the loader further
// while keeping the motion readable; HOLD_DURATION is sized to match it.
export const ANIMATION_SPEED = 1.25

const markup = animationSvg.replace(/<rect [^>]*\/>/, '')

const toCssValue = (element, value) => {
    const type = element.getAttribute('type')
    const [x, y = x] = value.trim().split(/[\s,]+/)

    if (type === 'translate') return `translate(${x}px, ${y}px)`
    if (type === 'scale') return `scale(${x}, ${y})`
    if (type === 'rotate') return `rotate(${x}deg)`

    return value
}

function playWithWebAnimations(svg) {
    svg.querySelectorAll('animate, animateTransform').forEach((element) => {
        const target = element.parentNode
        const property = element.tagName === 'animateTransform' ? 'transform' : element.getAttribute('attributeName')
        const values = element.getAttribute('values').split(';')
        const keyTimes = (element.getAttribute('keyTimes') || '').split(';')
        const keySplines = element.getAttribute('calcMode') === 'spline' ? element.getAttribute('keySplines').split(';') : []

        const keyframes = values.map((value, i) => ({
            [property]: toCssValue(element, value),
            offset: keyTimes[i] !== undefined && keyTimes[i] !== '' ? parseFloat(keyTimes[i]) : i / (values.length - 1),
            easing: keySplines[i] ? `cubic-bezier(${keySplines[i].trim().split(/[\s,]+/).join(', ')})` : 'linear'
        }))

        element.remove()

        target.animate(keyframes, {
            duration: parseFloat(element.getAttribute('dur')) * 1000,
            fill: 'forwards'
        }).playbackRate = ANIMATION_SPEED
    })
}

function LoaderAnimation() {
    const wrap = useRef(null)

    useEffect(() => {
        const svg = wrap.current && wrap.current.querySelector('svg')

        if (svg && typeof svg.animate === 'function') {
            playWithWebAnimations(svg)
        }
    }, [])

    return <div ref={wrap} data-loader-animation='' dangerouslySetInnerHTML={{ __html: markup }} />
}

export default LoaderAnimation
